import React from 'react';
import ScenarioSelectionRedefinedWrapperTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate';
import metaOverrideSet from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/MetaOverrideSet';
import fr from 'facet-rest';
import {
  ScenarioSelectionRedefinedPostSelectionNextUpActionsStepContent,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPostSelectionNextUpActionsStepTemplate/Content/ScenarioSelectionRedefinedPostSelectionNextUpActionsStepContent';
import useHomeContext from 'Context/HomeContext';
import useComponentDidMount from 'Hooks/useComponentDidMount';


const RoadmapDeliverablePostSelectionNextUpActionsStepTemplate = ({
  resource,
}) => {
  const { refreshHomeResource, homeResource } = useHomeContext();

  // Refresh home resource if scenario review relationship still exists, as the Scenarios tab on the nav bar should now
  // take you to the scenario you just selected.
  useComponentDidMount(async () => {
    if (homeResource.relationship(fr.relationships.scenarioReview.name)) {
      await refreshHomeResource();
    }
  });

  return (
    <ScenarioSelectionRedefinedWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      showBottomStepNavigators={false}
      layout={ScenarioSelectionRedefinedPostSelectionNextUpActionsStepContent}
    />
  );
};

export { RoadmapDeliverablePostSelectionNextUpActionsStepTemplate };
